var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',_vm._b({class:{ 'cursor-default': !_vm.to },attrs:{"to":_vm.goToRoute}},'nuxt-link',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }